import React from "react";
import { Modal, Button } from "react-bootstrap";
import { formatPrefixedProductLabel } from "../../util/productLabel";

/**
 * ItemCompletionGuardModal
 *
 * Shown when service completion is blocked by incomplete items.
 * Displays item progress and offers "Force Complete Anyway" option.
 */
const ItemCompletionGuardModal = ({
  show,
  onHide,
  serviceName,
  taskStatus,
  onForceComplete
}) => {
  const completed = taskStatus?.completed || 0;
  const total = taskStatus?.total || 0;
  const incomplete = total - completed;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa-sharp fa-regular fa-exclamation-triangle text-warning mr-2"></i>
          Incomplete Service Items
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>{completed}</strong> of <strong>{total}</strong> items completed
          for <strong>{serviceName || 'this service'}</strong>.
        </p>

        {incomplete > 0 && (
          <p className="text-muted">
            {incomplete} item{incomplete !== 1 ? 's' : ''} still {incomplete !== 1 ? 'need' : 'needs'} a
            product assigned before this service can be completed.
          </p>
        )}

        {taskStatus?.items && taskStatus.items.length > 0 && (
          <div className="mt-3">
            <small className="text-muted d-block mb-2">Item Status:</small>
            <div className="list-group list-group-flush">
              {taskStatus.items.map((item, idx) => (
                <div key={idx} className="list-group-item py-1 px-2 d-flex align-items-center">
                  <i className={`fa-sharp fa-regular ${item.completed ? 'fa-check-circle text-success' : 'fa-circle text-muted'} mr-2`}></i>
                  <span className="flex-grow-1">{item.label}</span>
                  {item.recommended_product_name ? (
                    <small className="text-success">{formatPrefixedProductLabel(item, 'recommended_product')}</small>
                  ) : (
                    <small className="text-muted">(no product)</small>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Go Back
        </Button>
        <Button variant="danger" onClick={onForceComplete}>
          Force Complete Anyway
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ItemCompletionGuardModal;
